import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useFetchLead from '../../hooks/useApi/useFetchLead';
import { useTranslation } from 'react-i18next';

const { Box, SubTitle, Table } = vp;
type KeyValuePair = {
  display: string;
  value: string;
};
type FC = FunctionComponent;
const Transaction: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [lead, getLead] = useFetchLead({});
  useEffect(() => {
    getLead(id);
  }, []);
  const { t } = useTranslation('translations', { keyPrefix: 'Leads.Details' });

  const leadDetailPairs: KeyValuePair[] = [
    {
      display: t('firstName'),
      value: lead.lead?.FirstName || '',
    },
    {
      display: t('lastName'),
      value: lead.lead?.LastName || '',
    },
    {
      display: t('leadStatus'),
      value: lead.lead?.LeadStatus || '',
    },
    {
      display: t('email'),
      value: lead.lead?.Email || '',
    },
    {
      display: t('company'),
      value: lead.lead?.Company || '',
    },
    {
      display: t('dba'),
      value: lead.lead?.DBA || '',
    },
    {
      display: t('website'),
      value: lead.lead?.Website || '',
    },
    {
      display: t(''),
      value: lead.lead?.BusinessModel || '',
    },
    {
      display: t('comments'),
      value: lead.lead?.Comments || '',
    },
  ];
  const tableProps: vp.TableProps = {
    name: 'account-details',
    variant: 'pair',
    columns: {
      detailKey: { header: 'Account Details' },
      detailValue: { header: '' },
    },
    rows: leadDetailPairs.map(({ display, value }) => ({
      detailKey: display,
      detailValue: value,
    })),
  };

  return (
    <div>
      <Box mt="lg" mb="md">
        <SubTitle subTitle={t('subTitle')} />
      </Box>
      <Table {...tableProps} />
    </div>
  );
};

export default Transaction;
